import { useEffect, useState } from 'react';

import InformationIcon from '~/assets/icons/Information';
import NewMailIcon from '~/assets/icons/NewMail';

type Props = {
  email: string;
};

export default function EmailSubmitted({ email }: Props) {
  const [showNudge, setShowNudge] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowNudge(true), 2500);
  });

  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 bg-grey-tile px-2 py-4 text-grey-hide">
      <div className="flex flex-col items-center justify-center gap-0">
        <NewMailIcon
          width="42"
          height="42"
          stroke="black"
          fill="none"
          circleStroke="black"
        />
        <span className="text-xs">Confirmation sent to {email}</span>
      </div>
      <span className="text-center text-base font-bold text-black">
        Click the link in your inbox and you’re all set up!
      </span>

      <div
        className={`flex w-full flex-row items-start justify-center gap-2 rounded-lg bg-yellow-label p-2 text-center transition-all duration-500 ease-out ${showNudge ? 'block scale-100 opacity-100' : 'absolute scale-50 opacity-0'}`}
      >
        <InformationIcon />
        <span className="text-xs font-semibold text-black">
          You won't receive stock notifications until you confirm your email.
        </span>
      </div>
    </div>
  );
}
